import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {RegisterValues} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import {Constants} from 'commons/constants';
import {Messages} from 'commons/constants';
import {CatalogValueShape} from 'commons/shapes';
import InnerFormRegister from './InnerFormRegister';

RegisterForm.propTypes = {
    foreign: PropTypes.bool.isRequired,
    submitHandler: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    personType: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(CatalogValueShape).isRequired,
};

const FormControl = withFormik<InferPropTypes<typeof RegisterForm.propTypes>, RegisterValues>({
    mapPropsToValues: (props) => {
        return {
            personType: props.personType || null,
            foreign: props.foreign,
            rol: Constants.CLIENT,
            download: false,
        };
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: RegisterValues) => {
        const errors: FormikErrors<RegisterValues> = {};

        if (!values.download) {
            if (!values.personType) {
                errors.personType = Messages.PERSON_TYPE_REQUIRED;
            }
        }

        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRegister);

function RegisterForm(props: InferPropTypes<typeof RegisterForm.propTypes>) {
    const {submitHandler, options, isLoading, personType, foreign} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <div className='Registerform'>
            <FormControl
                personType={personType}
                submitHandler={submitHandler}
                options={options}
                isLoading={isLoading}
                foreign={foreign}
            />
        </div>
    );
}

export default RegisterForm;
